const config = (window.XPER_CONFIG && window.XPER_CONFIG.drive) || {
  name: "XperDrive Lib",
  baseURL: "https://dev-api.bizbize.live/xperdrive",
};

export default config;
